
var id = "add_photo_alternate";
var markup = "<symbol viewBox=\"0 0 38 38\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"add_photo_alternate\">\n    <title>34. Icons/filled/image/add_photo_alternate_24px</title>\n    <defs>\n        <path d=\"M38,14 L38,19.98 C38,19.98 34.02,20 34,19.98 L34,14 L28,14 C28,14 28.02,10.02 28,10 L34,10 L34,4 L38,4 L38,10 L44,10 L44,14 L38,14 Z M32,22 L32,16 L26,16 L26,10 L10,10 C7.8,10 6,11.8 6,14 L6,38 C6,40.2 7.8,42 10,42 L34,42 C36.2,42 38,40.2 38,38 L38,22 L32,22 Z M10,38 L16,30 L20,36 L26,28 L34,38 L10,38 Z\" id=\"add_photo_alternate_path-1\" />\n    </defs>\n    <g id=\"add_photo_alternate_商品管理V2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"add_photo_alternate_编辑-未填写\" transform=\"translate(-369.000000, -747.000000)\">\n            <g id=\"add_photo_alternate_编组-5\" transform=\"translate(312.000000, 692.000000)\">\n                <g id=\"add_photo_alternate_34.-Icons/filled/image/add_photo_alternate_24px\" transform=\"translate(51.000000, 51.000000)\">\n                    <mask id=\"add_photo_alternate_mask-2\" fill=\"white\">\n                        <use xlink:href=\"#add_photo_alternate_path-1\" />\n                    </mask>\n                    <use id=\"add_photo_alternate_icon/image/add_photo_alternate_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#add_photo_alternate_path-1\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
